import { useState } from "react";
import { Boot } from "./components/Boot";
import { WorldPane } from "./components/WorldPane";

export function App() {
  const [booted, setBooted] = useState(false);
  return (
    <>
      {!booted && <Boot onDone={() => setBooted(true)} />}
      <WorldPane />
    </>
  );
}
